import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'facility_requires_use_contraceptives_other_forms_birth_control_2'

export const dataPointDefinition = {
  retracedId: 'facility_requires_use_contraceptives_other_forms_birth_control_2',
  name: 'Facility requires the use of contraceptives or other forms of birth control at any time during employment',
  description:
    'Select this option if the facility requires that workers use contraceptives or other forms of birth control at any time during employment.',
  meta: {
    slcpMeta: {
      key: 'disc-8--2-2x',
      number: 'WT-DIS-14-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'disc-8--2-2x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26890,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
